import { applySnapshot, getSnapshot, types } from 'mobx-state-tree'
import { fromPromise } from 'mobx-utils'
import { apiV1 } from '../../utils'
import { when } from 'mobx'

const PermissionModel = types.model('PermissionModel', {
  id: types.identifierNumber,
  name: types.string,
})

const PermissionStore = types
  .model('PermissionStore', {
    _data: types.optional(types.array(PermissionModel), []),
    _isPending: false,
  })
  .actions(self => {
    const API_URL = '/Permissions'

    const setPermissions = permissions => {
      applySnapshot(self._data, permissions)
    }

    const getPermissions = () => {
      const request = fromPromise(apiV1.get(API_URL))
      when(() =>
        request.case({
          fulfilled: res => {
            setPermissions(res.data)
            return true
          },
        }),
      )
      return request
    }

    return { getPermissions }
  })
  .views(self => ({
    get permissions() {
      return getSnapshot(self._data)
    },
  }))

export default PermissionStore
